import { useEffect, useRef, useState } from "react";
import { getToken } from "../utils/auth";

const API_URL = process.env.REACT_APP_API_URL || "https://app.nvplaydigital.com";

export default function Chat() {
  const [mensagens, setMensagens] = useState([]);
  const [texto, setTexto] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);
  const [solicitacaoAtiva, setSolicitacaoAtiva] = useState(null);
  const fim = useRef(null);
  const headers = { "Content-Type": "application/json", Authorization: getToken() };

  useEffect(() => {
    let ativo = true;
    async function carregarMensagens() {
      try {
        const r = await fetch(`${API_URL}/chat-sdvision/mensagens`, { headers });
        if (!r.ok) throw new Error();
        const d = await r.json();
        if (!ativo) return;
        setMensagens(d.mensagens || []);
        setSolicitacaoAtiva(d.solicitacaoAtiva || null);
        setErro("");
      } catch {
        if (ativo) setErro("Você não tem acesso a este atendimento.");
      } finally {
        if (ativo) setCarregando(false);
      }
    }
    carregarMensagens();
    const atualizador = setInterval(carregarMensagens, 5000);
    return () => { ativo = false; clearInterval(atualizador); };
  }, []);

  useEffect(() => {
    fim.current?.scrollIntoView({ behavior: "smooth" });
  }, [mensagens]);

  async function enviar(e) {
    e.preventDefault();
    const valor = texto.trim();
    if (!valor || solicitacaoAtiva) return;
    setTexto(""); setErro("");
    const provisoria = { _id: `local-${Date.now()}`, papel: "user", texto: valor };
    setMensagens((m) => [...m, provisoria]);
    try {
      const r = await fetch(`${API_URL}/chat-sdvision/mensagens`, { method: "POST", headers, body: JSON.stringify({ texto: valor }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMensagens((m) => [...m.filter((x) => x._id !== provisoria._id), { papel: "user", texto: valor }, d.mensagem]);
      setSolicitacaoAtiva(d.solicitacaoAtiva || null);
    } catch (err) {
      setMensagens((m) => m.filter((x) => x._id !== provisoria._id));
      setErro(err.message || "Não foi possível enviar.");
    }
  }

  return <div className="chat"><style>{css}</style><h1>💬 Suporte SD Vision</h1><p>Tire dúvidas sobre a operação e solicite recarga quando precisar.</p>{solicitacaoAtiva && <div className="processando">⏳ Recarga de {solicitacaoAtiva.servidor} em processamento. Aguarde a confirmação.</div>}<div className="caixa">{carregando ? "Carregando conversa..." : mensagens.length ? mensagens.map((m, i) => <div key={m._id || i} className={`msg ${m.papel}`}><b>{m.papel === "assistant" ? "SD Vision" : "Você"}</b><span>{m.texto}</span></div>) : <div className="vazio">Olá! 👋{"\n\n"}Aqui é o Suporte SD Vision.{"\n\n"}Posso ajudar com lançamentos, relatórios, fechamento semanal, ranking e uso do Gestor One.{"\n\n"}Para solicitar crédito, escreva:{"\n"}• Recarga Atmos{"\n"}• Recarga Stark</div>}<div ref={fim}/></div>{erro && <div className="erro">{erro}</div>}<form onSubmit={enviar}><input disabled={Boolean(solicitacaoAtiva)} value={texto} onChange={(e) => setTexto(e.target.value)} maxLength="1500" placeholder={solicitacaoAtiva ? "Aguarde a conclusão da recarga..." : "Digite sua dúvida ou solicitação..."}/><button disabled={Boolean(solicitacaoAtiva)}>{solicitacaoAtiva ? "Processando" : "Enviar"}</button></form></div>;
}

const css = `.chat{max-width:900px;margin:auto}.chat h1{margin-bottom:4px}.chat p{color:#64748b}.processando{margin:14px 0;padding:12px 14px;border-radius:12px;background:#fff7ed;color:#9a3412;font-weight:700}.caixa{height:60vh;min-height:420px;overflow:auto;background:#071024;border-radius:18px;padding:18px;color:#fff;display:flex;flex-direction:column;gap:12px}.msg{max-width:78%;padding:12px 14px;border-radius:14px;display:grid;gap:5px}.msg.user{align-self:flex-end;background:#4f46e5}.msg.assistant{align-self:flex-start;background:#18243b}.msg b{font-size:12px;color:#c7d2fe}.msg span{white-space:pre-wrap}.vazio{margin:auto;color:#cbd5e1;text-align:center;white-space:pre-line;line-height:1.6}.erro{color:#b91c1c;margin:10px 0}form{display:flex;gap:10px;margin-top:14px}input{flex:1;padding:14px;border:1px solid #cbd5e1;border-radius:12px;font-size:16px}button{border:0;border-radius:12px;background:#4f46e5;color:#fff;font-weight:700;padding:0 22px;cursor:pointer}button:disabled,input:disabled{opacity:.6;cursor:not-allowed}`;
